import { action, observable, flow, makeObservable } from 'mobx';
import { ApiResponse, GlobalStore } from '@roc/feature-app-core';
import { CounterPartyExpensesTab, HistoryEntry } from '../types/types';
import { SpecialServicingBaseStore } from './specialServicingBaseStore';
import { Option } from '@roc/ui/utils';

export class ReceivablesDashboardStore extends SpecialServicingBaseStore {
  investorOptions: Option[] = [];
  historyModalOpen: boolean = false;
  historyRecord: any = null;
  receivableHistory: HistoryEntry[] = [];
  historyLoading: boolean = false;

  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.tab = CounterPartyExpensesTab.PENDING_RECEIVABLE;
    makeObservable(this, {
      fetchEntityNames: flow,
      performActions: flow,
      performAction: flow,
      updateReceivableAdjustment: flow,
      investorOptions: observable,
      historyModalOpen: observable,
      historyRecord: observable,
      receivableHistory: observable,
      historyLoading: observable,
      openHistoryModal: action,
      closeHistoryModal: action,
      fetchReceivableHistory: flow,
    });
  };

  openHistoryModal(record: any) {
    this.historyRecord = record;
    this.historyModalOpen = true;
    this.fetchReceivableHistory(record.recordId);
  }

  closeHistoryModal() {
    this.historyModalOpen = false;
    this.historyRecord = null;
    this.receivableHistory = [];
  }

  *fetchReceivableHistory(receivableId: number | string) {
    this.historyLoading = true;
    try {
      const response: ApiResponse = yield this.service.getReceivableHistory(receivableId);
      this.receivableHistory = response.data.data;
      this.historyLoading = false;
    } catch (error) {
      this.historyLoading = false;
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while fetching receivable history.',
      });
    }
  }

  *fetchEntityNames() {
    try {
      const response: ApiResponse = yield this.service.getInvestorNames();
      this.entityList = response.data.data.map(value => ({
        label: value.name,
        value: value.companyId
      }));
      this.investorOptions = this.entityList.map(value => ({
        label: value.label,
        value: value.label
      }));
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while fetching investor names.',
      });
    }
  };

  reset() {
    this.tab = CounterPartyExpensesTab.PENDING_RECEIVABLE;
    this.counterPartyExpenseGridStore.reset();
  };

  *performActions(status: string) {
    try {
      const response = yield this.service.performReceivableAction(this.recordsIds, status);
      if (response.data.status === 'OK') {
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Status updated successfully.'
        });
      }
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while updating status.',
      });
    }
  }

  *performAction(id: number, status: string) {
    const idList: number[] = [id];

    try {
      const response = yield this.service.performReceivableAction(idList, status);
      if (response.data.status === 'OK') {
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Status updated successfully.'
        });
      }
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while updating status.',
      });
    }
  }

  *updateReceivableAdjustment(receivableId: number, adjustment: number, comment: string) {
    try {
      const response: ApiResponse = yield this.service.updateReceivableAdjustment(receivableId, adjustment, comment);
      if (response.data.status === 'OK') {
        this.globalStore.notificationStore.showSuccessNotification({
          message: 'Adjustment updated successfully.'
        });
      }
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while updating adjustment.',
      });
    }
  }

}
